<template lang="pug">
  div.staff-management.employee-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title
          template(v-if="fields && fields.id") {{fields.fio}}
          template(v-else) Добавление новой записи
        div.tabs
          span(@click="tabView = 'tab1'" :class="activeClass('tab1')") Общие сведения
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-group(
                  name="fio"
                  inputType="input"
                  label="ФИО"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                e-form-group(
                  name="staff_position_id"
                  inputType="select"
                  label="Должность"
                  :model="fields"
                  tabView="tab1"
                  :options="positions"
                  :required="true"
                )
                e-form-group(
                  name="personnel_number"
                  label="Табельный номер"
                  :model="fields"
                  tabView="tab1"
                  :required="false"
                )
                e-form-group(
                  name="phone"
                  label="Телефон"
                  :model="fields"
                  tabView="tab1"
                  :required="false"
                  mask="+7(###) ###-##-##"
                )
                e-form-group(
                  name="email"
                  label="E-mail"
                  :model="fields"
                  tabView="tab1"
                  :required="false"
                  validationRule="email"
                )

              div.col
                template(
                  v-if="isDriver"
                )
                  e-form-group(
                    name="cert_num"
                    inputType="input"
                    label="Номер удостоверения"
                    :model="fields"
                    tabView="tab1"
                  )
                  e-form-group(
                    name="driver_class_id"
                    inputType="select"
                    :options="driverClasses"
                    label="Класс"
                    :model="fields"
                    tabView="tab1"
                  )
                  e-form-group(
                    name="license_id"
                    inputType="select"
                    :options="licenses"
                    label="Лицензионная карточка"
                    :model="fields"
                    tabView="tab1"
                  )
                  e-form-group(
                    name="reg_num"
                    inputType="input"
                    label="Регистрационный номер"
                    :model="fields"
                    tabView="tab1"
                  )
                  e-form-group(
                    name="passport_serial"
                    inputType="input"
                    label="Серия"
                    :model="fields"
                    tabView="tab1"
                  )
                  e-form-group(
                    name="passport_number"
                    inputType="input"
                    label="Номер"
                    :model="fields"
                    tabView="tab1"
                  )

              div.col

</template>

<script>
  import {transport} from '../../api/api-endpoints'
  import {EMPLOYEE_POSITION_DRIVER} from '../../config/config'
  import employeeFormMixin from  './mixins/employee-form.js'

  export default {
    mixins: [employeeFormMixin],
    data () {
      return {
        tabView: 'tab1',
        fields: {
          fio: '',
          staff_position_id: '',
          personnel_number: '',
          phone: '+7()',
          email: '',
          cert_num: '',
          driver_class_id: '',
          license_id: '',
          reg_num: '',
          passport_serial: '',
          passport_number: '',
        }
      }
    },
    computed: {
      isDriver() {
        return this.fields.staff_position_id === EMPLOYEE_POSITION_DRIVER
      }
    },
    methods: {
      getUpdateOrCreateUrl () {
        return this.$route.params.id ? transport.employee(this.$route.params.id) : transport.employee()
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return transport.employee(route.params.id)
      }
    }
  }
</script>
